import { useGetAssuranceLevelQuery } from "@/store/services/supabase";
import { currentPathWithQuery, loginHref } from "@/utils/url";
import { useSession } from "@supabase/auth-helpers-react";
import { useRouter } from "next/router";
import { useEffect } from "react";

export const useRequireSession = () => {
  const session = useSession();
  const router = useRouter();
  const { data: assuranceLevel, isLoading, refetch } = useGetAssuranceLevelQuery();

  // Check if another tab is successfully signed in
  useEffect(() => {
    refetch();
  }, []);

  // An unverified session is denied every query due to RLS restriction
  const isVerified = !!session && !!assuranceLevel?.hasVerifiedMFA;

  useEffect(() => {
    if (isVerified) return;

    if (session && isLoading) return;

    router.replace(loginHref(currentPathWithQuery()));
  }, [isVerified, session, isLoading]);

  return isVerified ? session : null;
};
